/**
 * WaitlistRpcClient - AtomRpc integration for waitlist endpoints
 *
 * Public endpoint - no authentication required.
 * Uses NDJSON serialization for consistency with other RPC endpoints.
 *
 * @example
 * ```typescript
 * const submitWaitlistAtom = WaitlistRpcClient.runtime.fn(
 *   Effect.fnUntraced(function*(params: { email: string; name?: string }) {
 *     const client = yield* WaitlistRpcClient;
 *     const entry = yield* client("waitlist.join", params);
 *     return entry;
 *   })
 * );
 * ```
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { WaitlistRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { ClerkTokenGetter, makeRpcClientLayer } from "./shared.ts";

export class WaitlistRpcClient extends AtomRpc.Tag<WaitlistRpcClient>()("WaitlistRpcClient", {
  group: WaitlistRpcs,
  protocol: makeRpcClientLayer(WaitlistRpcs).pipe(
    Layer.provide(RpcSerialization.layerNdjson),
    Layer.provide(ClerkTokenGetter.Default), // No auth needed, use default (null token)
    Layer.provide(FetchHttpClient.layer),
  ),
}) {}
